module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "block_",
    attrs: {
      "id": "id_Hlk61959347"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "block_"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_"
  }), _vm._v(" "), _c('h1', {
    staticClass: "block_1",
    attrs: {
      "id": "toc_id_1",
      "lang": "en"
    }
  }, [_vm._v("About the Author")]), _vm._v(" "), _c('p', {
    staticClass: "block_"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_2"
  }, [_c('span', {
    attrs: {
      "lang": "en"
    }
  }, [_vm._v("David Moore was born in Ireland and later emigrated to Montreal. Moore published his first collection of poetry, ")]), _c('i', {
    staticClass: "calibre1",
    attrs: {
      "lang": "en"
    }
  }, [_vm._v("Silence")]), _c('span', {
    attrs: {
      "lang": "en"
    }
  }, [_vm._v(", in 2016. Other books followed: ")]), _c('i', {
    staticClass: "calibre1",
    attrs: {
      "lang": "en"
    }
  }, [_vm._v("Poems 2020, The March of the Copylong Shadows, 2020, Fame and Fortune, The Copyright Curse of Cassandra, 2021, The Life of a Slave, 2022,")]), _c('span', {
    attrs: {
      "lang": "en"
    }
  }, [_vm._v(" and ")]), _c('i', {
    staticClass: "calibre1",
    attrs: {
      "lang": "en"
    }
  }, [_vm._v("The Timeless Love of Billy B for Scheherazade, 2022")]), _c('span', {
    attrs: {
      "lang": "en"
    }
  }, [_vm._v(". ")]), _c('i', {
    staticClass: "calibre1",
    attrs: {
      "lang": "en"
    }
  }, [_vm._v("Evening Light over Kouraki")]), _c('span', {
    attrs: {
      "lang": "en"
    }
  }, [_vm._v(" is his first novel. He is presently working on another full-length novel, ")]), _c('i', {
    staticClass: "calibre1",
    attrs: {
      "lang": "en"
    }
  }, [_vm._v("Things Not Said")]), _c('span', {
    attrs: {
      "lang": "en"
    }
  }, [_vm._v(". Moore has already made his mark as a visual artist in Canada, the USA, and Europe. "), _c('br', {
    staticClass: "calibre2",
    attrs: {
      "id": "calibre_pb_0"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2bff6952","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/index_split_000.vue
// module id = 63
// module chunks = 0